import $ from 'jquery';

export default function () {
  const url = new URL(location.href);

  if (url.hash != -1) {
    return url.hash;
  }
}
